let sortBySelect = document.querySelector('.sortBySelect');
let sortByArrow = document.querySelector('.sort_By_arrow');

if (sortByArrow != null) {
  sortBySelect.addEventListener("click", function(){ 
    if(sortByArrow.classList.contains('sortByArrowOpenClose')){
      sortByArrow.classList.remove('sortByArrowOpenClose');
    }else{
      sortByArrow.classList.toggle('sortByArrowOpenClose');
    }
  });
}
/* Announcement carousel */
var elem = document.querySelector('.announcement-carousel');
var flkty = new Flickity( elem, {
  prevNextButtons: false,
  wrapAround: true,
  contain: true
});